import { createContext, useContext } from "react";
import { API_DIRECTORY_THEME } from "../utils/constants";

const DirectoryTypeContext = createContext(
  API_DIRECTORY_THEME.ISV_API_DIRECTORY
);

export function DirectoryTypeProvider({ children, directoryType }) {
  return (
    <DirectoryTypeContext.Provider value={directoryType}>
      {children}
    </DirectoryTypeContext.Provider>
  );
}

export const useDirectoryType = () => useContext(DirectoryTypeContext);
